import { PricingFromCdn } from '@nemuru-eng/js-api-client/slim';
import { z } from 'zod';

import { LoanConditionsCalculator } from '@/components/widgets/LoanDetailActions/components/LoanDetailActionsDialog/components/ChangeLoanConditionsDialog/entities/LoanConditionsCalculator';
import { ChangeLoanConditions } from '@/components/widgets/LoanDetailActions/components/LoanDetailActionsDialog/components/ChangeLoanConditionsDialog/services/ChangeLoanConditions';
import { requiredString } from '@/utils/zodUtils';

export const ChangeLoanConditionsSchema = (
  t: (textId: string | number) => string,
  pricings: PricingFromCdn[] | null,
) => {
  const LoanConditionsInstance = LoanConditionsCalculator.getInstance();
  return z
    .object({
      pricingId: requiredString(t),
      principal: requiredString(t),
      term: requiredString(t),
    })
    .refine(
      (data) => {
        if (!pricings) return false;
        const selectedPricing = ChangeLoanConditions.getPricingById(pricings, data.pricingId);
        if (!selectedPricing) return false;

        if (
          selectedPricing.rangePrincipalMin.value > Number(data.principal) ||
          selectedPricing.rangePrincipalMax.value < Number(data.principal)
        )
          return false;
        return true;
      },
      { message: t('INVALID_PRINCIPAL_VALUE'), path: ['principal'] },
    )
    .refine(
      (data) => {
        if (!pricings) return false;
        const selectedPricing = ChangeLoanConditions.getPricingById(pricings, data.pricingId);
        if (!selectedPricing) return false;

        if (
          (selectedPricing.rangePeriodMin && selectedPricing.rangePeriodMin > Number(data.term)) ||
          (selectedPricing.rangePeriodMax && selectedPricing.rangePeriodMax < Number(data.term))
        )
          return false;
        return true;
      },
      { message: t('INVALID_TERM_VALUE'), path: ['term'] },
    )
    .refine(
      () => {
        if (!LoanConditionsInstance.getLoanCalculator()) {
          return false;
        }
        return true;
      },
      { message: t('LOAN_CALCULATOR_NOT_FOUND_FOR_THE_GIVEN_TERM'), path: ['term'] },
    );
};

export type ChangeLoanConditionsType = z.infer<ReturnType<typeof ChangeLoanConditionsSchema>>;
